import { http } from '../../utils'
import { AxiosResponse } from 'axios'

const BASE = `${process.env.EWAY_API_BASE_URL}`

export interface GSTPortalResponse {
  success: boolean
  message: string
  code?: number
  errorCode?: string
  data?: {
    ackNo?: string
    message?: string
  }
}

export function requestGSTOtp(): Promise<AxiosResponse<GSTPortalResponse>> {
  return http.post(`${BASE}gst/auth/request-otp`)
}

export function verifyGSTOtp(otp: string): Promise<AxiosResponse<GSTPortalResponse>> {
  return http.post(`${BASE}gst/auth/verify-otp`, { otp })
}

export function saveGSTR1ToPortal(
  retPeriod: string,
  gstr1Json: Record<string, any>
): Promise<AxiosResponse<GSTPortalResponse>> {
  return http.post(`${BASE}gst/returns/gstr1/save`, { retPeriod, gstr1Json })
}

export function saveGSTR3BToPortal(
  retPeriod: string,
  gstr3bJson: Record<string, any>
): Promise<AxiosResponse<GSTPortalResponse>> {
  return http.post(`${BASE}gst/returns/gstr3b/save`, { retPeriod, gstr3bJson })
}
